import { render, staticRenderFns } from "./LimitServices.vue?vue&type=template&id=d279ab9e&"
import script from "./LimitServices.vue?vue&type=script&lang=js&"
export * from "./LimitServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports